/* Lightweight feature checks mirroring Modernizr setClasses */
(function () {
  try {
    var docEl = document.documentElement;
    // Toggle js/no-js
    docEl.className = docEl.className.replace(/\bno-js\b/, '').trim();
    if (!/\bjs\b/.test(docEl.className)) docEl.className += (docEl.className ? ' ' : '') + 'js';

    var classes = [];

    // Flexbox
    var hasFlex = false;
    if (window.CSS && CSS.supports) {
      hasFlex = CSS.supports('display', 'flex') || CSS.supports('display', 'inline-flex');
    } else {
      var el = document.createElement('div');
      try { el.style.display = 'flex'; hasFlex = (el.style.display === 'flex'); } catch (e) { hasFlex = false; }
    }
    classes.push(hasFlex ? 'flexbox' : 'no-flexbox');

    // ES6 Promises
    var hasPromises = typeof Promise !== 'undefined' && Promise.resolve;
    classes.push(hasPromises ? 'promises' : 'no-promises');

    // Service Worker
    var hasSW = 'serviceWorker' in navigator;
    classes.push(hasSW ? 'serviceworker' : 'no-serviceworker');

    // Apply classes
    docEl.className += (docEl.className ? ' ' : '') + classes.join(' ');
  } catch (e) {
    // noop
  }
})();

